module.exports = function() {
	$('.js-vacancy_trigger').click(function() {
		$(this).prev('.js-vacancy-content').slideToggle('fast');

		var text = $(this).text();

		$(this).text(text == "Подробнее" ? "Свернуть" : "Подробнее");
	})
}


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/vacancy.js
 **/